import type { Portal } from '@/types/api';

const SESSION_EXPIRED_KEY = 'scube_session_expired';

export function redirectToLoginWithReturn(portal: Portal): void {
  const redirect = encodeURIComponent(window.location.pathname + window.location.search);
  sessionStorage.setItem(SESSION_EXPIRED_KEY, '1');
  window.location.assign(`/public/login?portal=${portal}&redirect=${redirect}&expired=1`);
}

export function consumeSessionExpiredFlag(): boolean {
  if (sessionStorage.getItem(SESSION_EXPIRED_KEY) !== '1') {
    return false;
  }
  sessionStorage.removeItem(SESSION_EXPIRED_KEY);
  return true;
}

/** Restrict post-login redirect to same portal paths only. */
export function sanitizePortalRedirect(portal: Portal, redirect: string | null): string | null {
  if (!redirect || !redirect.startsWith('/')) {
    return null;
  }
  if (portal === 'admin' && redirect.startsWith('/admin')) {
    return redirect;
  }
  if (portal === 'tenant' && redirect.startsWith('/tenant')) {
    return redirect;
  }
  return null;
}
